export const validateDeviceCaps = (value) => {
    if (!value || typeof value !== "object" || Array.isArray(value))
        return undefined;
    const total = Object.values(value).reduce((acc, curr) => acc + curr, 0);
    if (total < 100) {
        return "Device cap sum cannot be lower than 100%.";
    }
    return undefined;
};
//# sourceMappingURL=deviceCaps.js.map